(function () {
  'use strict';

  var TEXT = {
    fi: {
      square: 'Neliötimantit',
      round: 'Pyöreät timantit',
      add: 'Lisää koko timanttisetti ostoskoriin',
      adding: 'Lisätään…',
      added: 'Timanttisetti lisätty ostoskoriin.',
      unavailable: 'Tämän maalauksen timanttisetti ei ole tällä hetkellä saatavilla.',
      notFound: 'Maalausta ei löytynyt. Tarkista tuotekoodi tai kokeile maalauksen nimeä.',
      loadError: 'Maalausten lataaminen epäonnistui. Yritä hetken kuluttua uudelleen.',
      cartError: 'Ostoskoriin lisääminen epäonnistui. Yritä uudelleen.',
      colorCount: '{count} väriä tässä työssä',
      showColors: 'Näytä kaikki {count} väriä',
      hideColors: 'Piilota koko värilista',
      dmcColor: 'DMC {code}'
    },
    en: {
      square: 'Square drills',
      round: 'Round drills',
      add: 'Add complete drill set to cart',
      adding: 'Adding…',
      added: 'Complete drill set added to cart.',
      unavailable: 'The complete drill set for this painting is currently unavailable.',
      notFound: 'Painting not found. Check the product code or try the painting name.',
      loadError: 'Paintings could not be loaded. Please try again shortly.',
      cartError: 'The item could not be added to the cart. Please try again.',
      colorCount: '{count} colours in this design',
      showColors: 'Show all {count} colours',
      hideColors: 'Hide full colour list',
      dmcColor: 'DMC {code}'
    }
  };

  function sampoJsTexts(area) {
    // a third language's texts, printed by the theme (snippets/sampo-js-texts) only outside fi and en
    try {
      var el = document.querySelector('script[data-sampo-js-texts="' + area + '"]');
      var own = el ? JSON.parse(el.textContent || 'null') : null;
      return own && typeof own === 'object' ? own : null;
    } catch (error) {
      return null;
    }
  }

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale === 'fi' ? 'fi-FI' : locale === 'en' ? 'en-IE' : locale, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init(root) {
    if (root.dataset.dpDiamondPickerReady === 'true') return;
    root.dataset.dpDiamondPickerReady = 'true';

    var locale = String(root.dataset.locale || 'fi').toLowerCase() === 'fi' ? 'fi' : 'en';
    // a third language (Swedish pilot B1): its texts lie over English, never Finnish
    var own = sampoJsTexts('dpset');
    var text = own ? Object.assign({}, TEXT.en, own) : TEXT[locale];
    var currency = root.dataset.currency || 'EUR';
    var dataUrl = root.dataset.paintingsUrl;
    var variantScript = root.querySelector('[data-dp-pricing-variants]');
    var variants = [];
    var paintings = [];
    var selected = null;

    try {
      variants = JSON.parse(variantScript ? variantScript.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-dp-mode-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-dp-mode-panel]'));
    var input = root.querySelector('[data-dp-painting-search]');
    var suggestions = root.querySelector('[data-dp-painting-suggestions]');
    var loading = root.querySelector('[data-dp-paintings-loading]');
    var result = root.querySelector('[data-dp-set-result]');
    var empty = root.querySelector('[data-dp-set-empty]');
    var status = root.querySelector('[data-dp-status]');
    var title = root.querySelector('[data-dp-set-title]');
    var sku = root.querySelector('[data-dp-set-sku]');
    var shape = root.querySelector('[data-dp-set-shape]');
    var colorSummary = root.querySelector('[data-dp-color-summary]');
    var colorCount = root.querySelector('[data-dp-color-count]');
    var swatchList = root.querySelector('[data-dp-set-swatches]');
    var colorsToggle = root.querySelector('[data-dp-colors-toggle]');
    var allColors = root.querySelector('[data-dp-all-colors]');
    var price = root.querySelector('[data-dp-set-price]');
    var addButton = root.querySelector('[data-dp-add-set]');

    function setMode(mode) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.dpModeTab === mode;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.dpModePanel !== mode;
      });
    }

    function showStatus(message, isError) {
      status.textContent = message || '';
      status.hidden = !message;
      status.classList.toggle('is-error', Boolean(isError));
      status.classList.toggle('is-success', Boolean(message) && !isError);
    }

    function paintingTitle(painting) {
      return painting.title || painting.name || painting.sku;
    }

    function searchText(painting) {
      return normalize([
        painting.sku,
        painting.title,
        painting.name,
        Array.isArray(painting.aliases) ? painting.aliases.join(' ') : ''
      ].join(' '));
    }

    function variantFor(painting) {
      return variants.find(function (variant) {
        return String(variant.sku || '').toUpperCase() === String(painting.variant_sku || '').toUpperCase();
      });
    }

    function clearSelection() {
      selected = null;
      result.hidden = true;
      empty.hidden = false;
      colorSummary.hidden = true;
      colorCount.textContent = '';
      swatchList.innerHTML = '';
      allColors.innerHTML = '';
      allColors.hidden = true;
      colorsToggle.setAttribute('aria-expanded', 'false');
      colorsToggle.textContent = '';
      addButton.disabled = true;
      addButton.classList.remove('dmc-picker__atc--active');
    }

    function renderSwatches(painting) {
      var palette = Array.isArray(painting.colors) ? painting.colors.filter(function (color) {
        return color && color.code && /^#[0-9A-F]{6}$/i.test(String(color.hex || ''));
      }) : [];
      var colors = Array.isArray(painting.swatches) ? painting.swatches.slice(0, 5) : [];
      swatchList.innerHTML = '';
      allColors.innerHTML = '';
      allColors.hidden = true;
      colorsToggle.setAttribute('aria-expanded', 'false');

      colors.forEach(function (color) {
        if (!/^#[0-9A-F]{6}$/i.test(String(color || ''))) return;
        var matching = palette.find(function (item) {
          return String(item.hex).toUpperCase() === String(color).toUpperCase();
        });
        var swatch = document.createElement('span');
        swatch.className = 'dp-diamond-picker__swatch';
        swatch.style.backgroundColor = color;
        swatch.title = matching ? text.dmcColor.replace('{code}', matching.code) : color;
        swatch.setAttribute('aria-hidden', 'true');
        swatchList.appendChild(swatch);
      });

      palette.forEach(function (color) {
        var item = document.createElement('span');
        var dot = document.createElement('span');
        var code = document.createElement('span');
        var label = text.dmcColor.replace('{code}', color.code) + (color.effect ? ' ' + color.effect.toUpperCase() : '');
        item.className = 'dp-diamond-picker__color-item';
        item.title = label;
        dot.className = 'dp-diamond-picker__color-dot';
        dot.style.backgroundColor = color.hex;
        dot.setAttribute('aria-hidden', 'true');
        code.textContent = color.code + (color.effect ? ' ' + color.effect.toUpperCase() : '');
        item.appendChild(dot);
        item.appendChild(code);
        allColors.appendChild(item);
      });

      var count = palette.length;
      colorCount.textContent = text.colorCount.replace('{count}', count);
      colorsToggle.textContent = text.showColors.replace('{count}', count);
      colorsToggle.hidden = !count;
      colorSummary.hidden = !count;
    }

    colorsToggle.addEventListener('click', function () {
      var expanded = colorsToggle.getAttribute('aria-expanded') === 'true';
      colorsToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      allColors.hidden = expanded;
      colorsToggle.textContent = expanded
        ? text.showColors.replace('{count}', allColors.children.length)
        : text.hideColors;
    });

    function selectPainting(painting) {
      var variant = variantFor(painting);
      selected = painting;
      input.value = paintingTitle(painting) + ' — ' + painting.sku;
      suggestions.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      empty.hidden = true;
      result.hidden = false;
      title.textContent = paintingTitle(painting);
      sku.textContent = painting.sku;
      shape.textContent = String(painting.shape || '').toLowerCase() === 'round' ? text.round : text.square;
      renderSwatches(painting);
      price.textContent = variant ? formatMoney(variant.price, currency, own && own.intlLocale ? own.intlLocale : locale) : '';
      addButton.disabled = !variant || variant.available === false;
      addButton.classList.toggle('dmc-picker__atc--active', Boolean(variant) && variant.available !== false);
      addButton.textContent = variant && variant.available !== false ? text.add : text.unavailable;
      showStatus('', false);
    }

    function renderSuggestions(query) {
      var clean = normalize(query);
      suggestions.innerHTML = '';
      if (!clean) {
        suggestions.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      var matches = paintings.filter(function (painting) {
        return searchText(painting).indexOf(clean) !== -1;
      }).slice(0, 8);

      if (!matches.length) {
        suggestions.innerHTML = '<div class="dp-diamond-picker__suggestion-empty">' + escapeHtml(text.notFound) + '</div>';
      } else {
        matches.forEach(function (painting) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'dp-diamond-picker__suggestion';
          button.setAttribute('role', 'option');
          button.innerHTML = '<strong>' + escapeHtml(paintingTitle(painting)) + '</strong><span>' + escapeHtml(painting.sku) + '</span>';
          button.addEventListener('click', function () {
            selectPainting(painting);
          });
          suggestions.appendChild(button);
        });
      }
      suggestions.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function selectFromQuery() {
      var requested = new URLSearchParams(window.location.search).get('painting');
      if (!requested) return;
      setMode('set');
      var normalizedSku = String(requested).trim().toUpperCase();
      var painting = paintings.find(function (item) {
        return String(item.sku || '').trim().toUpperCase() === normalizedSku;
      });
      if (painting) {
        selectPainting(painting);
      } else {
        input.value = requested;
        clearSelection();
        showStatus(text.notFound, true);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setMode(tab.dataset.dpModeTab);
      });
    });

    input.addEventListener('input', function () {
      clearSelection();
      showStatus('', false);
      renderSuggestions(input.value);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        suggestions.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) {
        suggestions.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }
    });

    addButton.addEventListener('click', function () {
      if (!selected) return;
      var variant = variantFor(selected);
      if (!variant || variant.available === false) return;

      addButton.disabled = true;
      addButton.textContent = text.adding;
      showStatus('', false);

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variant.id),
            quantity: 1,
            properties: { SKU: selected.sku }
          }]
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function () {
          addButton.textContent = text.add;
          addButton.disabled = false;
          showStatus(text.added, false);
          return fetch(cartRoot() + 'cart.js');
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count], .header__cart-count').forEach(function (element) {
            element.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        })
        .catch(function () {
          addButton.textContent = text.add;
          addButton.disabled = false;
          showStatus(text.cartError, true);
        });
    });

    fetch(dataUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Paintings request failed');
        return response.json();
      })
      .then(function (data) {
        paintings = Array.isArray(data) ? data : (Array.isArray(data.paintings) ? data.paintings : []);
        paintings = paintings.filter(function (painting) {
          return painting && painting.sku && painting.variant_sku;
        });
        loading.hidden = true;
        selectFromQuery();
      })
      .catch(function () {
        loading.hidden = true;
        clearSelection();
        showStatus(text.loadError, true);
      });
  }

  function boot() {
    document.querySelectorAll('[data-dp-diamond-picker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
